import React, { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { getYouTubeThumbnail, getYouTubeTitle, getYouTubeVideoId } from "util/helper";
import './VideosGrid.scss'

const ShimmerTitle = () => (
  <div className="shimmer">
    <div className="line"></div>
    <div className="line"></div>
  </div>
);

const VideoGrid = ({ videos }) => {
  const [titles, setTitles] = useState({});

  useEffect(() => {
    const fetchTitles = async () => {
      const titleMap = {};
      for (const item of videos) {
        if (item.type === "youtube") {
          const videoId = getYouTubeVideoId(item.src);
          if (videoId) {
            titleMap[item.src] = await getYouTubeTitle(videoId);
          }
        }
      }
      setTitles(titleMap);
    };
    fetchTitles();
  }, [videos]);

  return (
    <div className="video-grid">
      {videos?.map((item, index) => (
        <div key={index} className="video-card">
          <a href={item.src} target="_blank" rel="noopener noreferrer">
            <div className="thumbnail-container">
              {item.type === "youtube" ? (
                <img
                  src={getYouTubeThumbnail(getYouTubeVideoId(item.src) || "")}
                  alt={`Thumbnail for ${item.title}`}
                />
              ) : (
                <div
                  className="background-image"
                  style={{ backgroundImage: `url(${item.src})` }}
                />
              )}
              <div className="overlay">
                {item.type === "youtube" ? (
                  <Play className="icon" />
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                    />
                  </svg>
                )}
              </div>
            </div>
            <div className="video-content">
              <div className="title-container">
                {item.type === "youtube" && !titles[item.src] ? (
                  <ShimmerTitle />
                ) : (
                  <h3 className="title">
                    {item.type === "youtube" ? titles[item.src] : item.title}
                  </h3>
                )}
              </div>
            </div>
          </a>
        </div>
      ))}
    </div>
  );
};

export default VideoGrid;